/**
 * @file Site entrypoint. This runs only in supported browsers and is
 * dynamically inserted by "bootstrap.js" if the user's browser is supported.
 *
 * This is LTA's core JS bundle; it includes store, routing,
 * component loading for routes, et al.
 */
import './components/VideoEmbed';
import './components/VideoEmbed/indexTf';
import './utils/loadTfSvgSprite';

// Import default components for all pages
//* This will be updated based ona router -> loader flow.
import './pages/default';

document.documentElement.classList.add('loaded');
